module.exports = __webpack_public_path__ + "img/centrosdesalud.bebabf5c.png";